import { combineReducers } from 'redux';

import {
  FETCH_USER_PURCHASES,
} from '../actions/index';

const addUserPurchases = (state, action) => {
  const { payload } = action;
  const purchaseIds = payload.purchases.map(purchase => purchase.id);

  return {
    ...state,
    [payload.user.id]: purchaseIds,
  };
};

const purchasesByUserId = (state = {}, action) => {
  switch (action.type) {
    case FETCH_USER_PURCHASES:
      return addUserPurchases(state, action);
    default:
      return state;
  }
};

export default combineReducers({
  byUserId: purchasesByUserId,
});



// WEBPACK FOOTER //
// ./src/reducers/user-purchases.reducer.js